import React from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import {FormId_TestFileSubmission , CLIENT_ID} from '../config.js'
import GetForm from './GetForm'
import { getItemAnonymous} from '../actions/user'
import { connect } from 'react-redux';
import {GET_FORM, SUBMIT_FORM,CREATE_FORM_ENTRIE} from '../actions/user';
import { UncontrolledAlert } from 'reactstrap';

class TestFileSubmission extends React.Component {
constructor(props){
  super(props);
  this.state={
    spinner_status:false,
  }
}
componentDidMount(){
    const url ='forms/'+FormId_TestFileSubmission+'/view/?client='+CLIENT_ID;
    this.setState({spinner_status:true});
    this.props.getItemAnonymous(url, GET_FORM);
  }
componentWillReceiveProps(nextProps) {
    this.setState({spinner_status:nextProps.spinner_status});
 }
    render() {
      const success  = this.props.success ? this.props.success :null;
      console.log('test mes' , {success});
    return (
	<div>


     <section id="login-register" className="ptb ptb-sm-80">
            <div className="container page-contact">
                <h3 className="text-center">Nous contacter</h3>
                <div className="row">
                <div className="spacer-75"></div> 
                
                 
                    <div className="col-md-6 offset-md-3 col-sm-8 offset-sm-2">
                    
                     {this.props.success ?
                      <UncontrolledAlert color="success">
                          {this.props.success}
                      </UncontrolledAlert>
                      :
                      this.props.error ?
                        <UncontrolledAlert color="danger">
                           {this.props.error}
                      </UncontrolledAlert>
                        : null
                    
                    }


                        <GetForm fields={this.props.fields} title={this.props.title} 
                        formId={FormId_TestFileSubmission} clientId={CLIENT_ID} spinner_status={this.state.spinner_status}
                        textbtn="Envoyer votre message"/>
                     
                       
                    </div>
                       
                </div>
            </div>
        </section>


    </div>


  )
 }
}
function mapStateToProps(state, ownProps){
  return {
    fields: state.dynamicform.fields,
    title: state.dynamicform.title,
    success: state.dynamicform.success,
    error: state.dynamicform.error,
    spinner_status:state.dynamicform.spinner_status,

  }
}  
export default connect(mapStateToProps, {getItemAnonymous})(TestFileSubmission);




// WEBPACK FOOTER //
// ./src/components/TestFileSubmission.jsx